import { FC } from "react";
import { usePushNotifications } from "../model/usePushNotifications";

/**
 * Headless. Re-posts this browser's subscription on every app open, and **never prompts**.
 *
 * This is what makes "opens the app → the device is registered" true without anyone opening
 * the burger menu. It is also the repair path for `pushsubscriptionchange`: browsers rotate a
 * subscription silently and fire that event inconsistently, so rather than half-handling it in
 * the service worker — which has no cookie to authenticate a POST with anyway — the app
 * re-registers on load. The endpoint is unique, so it is an idempotent upsert.
 *
 * Mounted inside AppLayout, which sits under RequireAuth, so it only ever runs for a
 * signed-in user.
 */
export const PushRegistrar: FC = () => {
  usePushNotifications({ silentRegisterOnMount: true });
  return null;
};
